module.exports = "/images/vendor/jquery-ui-dist/ui-icons_555555_256x240.png?a1dfe2a71a43bf01990892ce37e2e6de";